import ScheduleBlockEditor from '../../../../components/ScheduleBlockEditor/ScheduleBlockEditor';
import { resolveListingAvailability } from '../../../../utils/availabilitySchedule';

export default function AvailabilitySection({
    listing,
    editMode = false,
    dirtyFields,
    setDirtyFields,
}) {
    const availability = editMode && dirtyFields
        ? (dirtyFields.availability ?? resolveListingAvailability(listing))
        : resolveListingAvailability(listing);

    const hasContent = availability.allDay || availability.schedule.length > 0;
    if (!editMode && !hasContent) {
        return null;
    }

    return (
        <div className="host-panel-section">
            <div className="host-panel-section-label">
                Hours of Availability
                <span className="ml-1 font-normal normal-case tracking-normal text-gray-400">
                    Set by You
                </span>
            </div>
            <p className="mb-3 text-xs leading-snug text-gray-500">
                Choose the days and hours your parking area is available for driver reservations. The default schedule is 9:00 PM to 8:00 AM daily, but you can customize it to fit your property's availability.
            </p>
            <ScheduleBlockEditor
                value={availability}
                readOnly={!editMode || !dirtyFields}
                defaultNote={null}
                onChange={(nextAvailability) => {
                    if (!setDirtyFields) return;
                    setDirtyFields((prev) => ({ ...prev, availability: nextAvailability }));
                }}
            />
        </div>
    );
}
